import Repository from './Repository';

class MetricRepository extends Repository {
	/**
	 * Gather all the data for main the dashboard page
	 *
	 * @returns {Promise<Array|Object|string>}
	 */
	dashboardMetrics () {
		return this.getWithToken('/metrics/dashboard');
	}

	/**
	 * Gather all metrics data for a group
	 *
	 * @param {int} groupId
	 * @returns {Promise<Array|Object|string>}
	 */
	groupMetrics (groupId) {
		return this.getWithToken(`/metrics/group?group=${groupId}`);
	}

	clientMetrics (clientId) {
		return this.getWithToken(`/metrics/client?client=${clientId}`);
	}
}

export default new MetricRepository();
